import util from 'util';

export const notifyOrLog = (error) => {
  console.error(error ? error.message : 'Error undefined');
  console.error(util.inspect(error)); // avoid 'converting circular structure to JSON' error
};
